// TODO: temp solution for disney dpi poc, need to remove
export const useAllowedMonths = (customerId) => {
  if ([1960188605, 1960188617, 1960185019].includes(customerId)) {
    return 3;
  }
  if ([1960186939].includes(customerId)) {
    return 6;
  }
  return 1;
};
